export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20minimalist%20product%20collage%20with%20diverse%20fashion%20items%20floating%20in%20elegant%20composition%2C%20soft%20warm%20terracotta%20and%20sand%20tones%20with%20sage%20green%20accents%2C%20negative%20space%2C%20editorial%20aesthetic%2C%20dreamy%20atmospheric%20lighting%20with%20gentle%20gradients%2C%20organic%20textures%20and%20flowing%20shapes%2C%20no%20text%2C%20clean%20minimal%20design%20with%20mediterranean%20vibe&width=1800&height=1200&seq=hero-v2-bg-2026&orientation=landscape"
        alt="CSSBuy Spreadsheet background"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-12 pt-24 pb-16">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-12 lg:gap-20 max-w-7xl mx-auto">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="flex -space-x-3">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border-2 border-white overflow-hidden bg-background-300">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20portrait%20close%20up%20young%20person%20with%20genuine%20warm%20smile%2C%20outdoor%20golden%20hour%20lighting%20with%20bokeh%20trees%2C%20modern%20casual%20style%2C%20approachable%20friendly%20look%2C%20lifestyle%20portrait%20photography&width=80&height=80&seq=hero-v2-avatar-01&orientation=squarish"
                    alt="Usuário"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border-2 border-white overflow-hidden bg-background-300">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20portrait%20close%20up%20woman%20with%20gentle%20confident%20smile%2C%20bright%20natural%20window%20light%2C%20elegant%20neutral%20blouse%2C%20friendly%20genuine%20expression%2C%20clean%20studio%20portrait%20photography&width=80&height=80&seq=hero-v2-avatar-02&orientation=squarish"
                    alt="Usuário"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border-2 border-white overflow-hidden bg-background-300">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20portrait%20close%20up%20young%20man%20with%20calm%20confident%20expression%2C%20urban%20background%20lightly%20blurred%2C%20modern%20style%2C%20approachable%20trustworthy%20look%2C%20editorial%20portrait%20photography&width=80&height=80&seq=hero-v2-avatar-03&orientation=squarish"
                    alt="Usuário"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <span className="text-white/90 text-sm md:text-base font-medium">
                Escolha de milhares de usuários
              </span>
            </div>

            <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-white leading-[1.05] mb-8">
              CSSBuy<br />Spreadsheet
            </h1>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="group inline-flex items-center gap-3 px-8 py-4 bg-primary-500 text-background-50 rounded-full text-base md:text-lg font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                CSSBuy Spreadsheet
                <i className="ri-arrow-right-line text-xl w-5 h-5 flex items-center justify-center group-hover:translate-x-1 transition-transform"></i>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="group inline-flex items-center gap-3 px-8 py-4 bg-white/15 backdrop-blur-sm text-white border border-white/40 rounded-full text-base md:text-lg font-semibold hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <i className="ri-arrow-right-line text-xl w-5 h-5 flex items-center justify-center group-hover:translate-x-1 transition-transform"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 lg:pt-20">
            <p className="text-white/85 text-lg md:text-xl leading-relaxed max-w-lg lg:ml-auto font-heading italic">
              O CSSBuy Spreadsheet é a ferramenta mais completa para organizar as suas compras internacionais da China. Compare preços, acompanhe encomendas e economize tempo com o sistema de spreadsheet mais avançado para agentes de compras chineses.
            </p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl w-6 h-6 flex items-center justify-center"></i>
      </div>
    </section>
  );
}